import _extends from '../../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _slicedToArray from '../../../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _objectWithoutProperties from '../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React, { forwardRef, useMemo } from 'react';
import 'prop-types';
import merge from 'deepmerge';
import ButtonBase from './ButtonBase.js';
import ButtonLoading from './ButtonLoading.js';
import useHover from '../../../utils/useHover.js';
import getPreferredValue from '../../../utils/getPreferredValue.js';
import btn from '../../../styles/btn.js';
import btnIcon from '../../../styles/btnIcon.js';
import btnLoading from '../../../styles/btnLoading.js';
import { margin1R } from '../../../styles/marginStatic/margin1R.js';
import { flexJustifyCenter } from '../../../styles/layout/flexJustifyCenter.js';
import { pad1Tb } from '../../../styles/padStatic/pad1Tb.js';
import { pad1 } from '../../../styles/padStatic/pad1.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
// eslint-disable-next-line complexity

var IconButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      children = _ref.children,
      loading = _ref.loading,
      loadingStyle = _ref.loadingStyle,
      size = _ref.size,
      otherProps = _objectWithoutProperties(_ref, ["icon", "children", "loading", "loadingStyle", "size"]);

  var _useHover = useHover(otherProps),
      _useHover2 = _slicedToArray(_useHover, 2),
      isHovering = _useHover2[0],
      hoverHandlerProps = _useHover2[1];

  var disabled = otherProps.disabled,
      theme = otherProps.theme;

  var _useMemo = useMemo(function () {
    return merge.all([btn.btn, theme['&:not(.btnContextual)'] ? theme['&:not(.btnContextual)'] : theme, disabled ? _objectSpread({}, theme['&:disabled'] ? theme['&:disabled'] : btn.btn['&:disabled']) : {}]);
  }, [theme, disabled]),
      color = _useMemo.color;

  var styleObject = useMemo(function () {
    return merge.all([size === 'sm' ? _objectSpread({}, btn.btnSm) : {}, btnIcon.btnIcon, !children ? _objectSpread(_objectSpread({}, btnIcon.btnIcon_btnSm_btnInline), flexJustifyCenter) : {}, loading ? btnLoading.btnLoading : {}, size !== 'sm' ? _objectSpread({
      maxHeight: '3.125rem'
    }, pad1Tb) : {}, size !== 'sm' && !children ? _objectSpread({}, pad1) : {}, theme]);
  }, [size, loading, children, theme]);
  var iconToRender = /*#__PURE__*/React.cloneElement(icon, {
    filled: getPreferredValue(icon.props.filled, !disabled && isHovering),
    size: icon.props.size || size || 'md',
    theme: _objectSpread(_objectSpread({}, children ? margin1R : {}), {}, {
      fill: color,
      lineHeight: 0
    }, icon.props.theme)
  });

  if (loading) {
    return /*#__PURE__*/React.createElement(ButtonLoading, _extends({}, otherProps, hoverHandlerProps, {
      loadingStyle: loadingStyle,
      theme: styleObject,
      ref: ref
    }), iconToRender, children);
  }

  return /*#__PURE__*/React.createElement(ButtonBase, _extends({}, otherProps, hoverHandlerProps, {
    theme: styleObject,
    ref: ref
  }), iconToRender, children);
});
IconButton.displayName = 'IconButton';
IconButton.defaultProps = {
  children: null
};

export default IconButton;
